import styled from 'styled-components'
import { FuelTypography } from '@frete.com/fuel-react'
import { CellProps, ColumnProps, LabelProps, RowsProps } from './interfaces'

export const DataTable = styled.table.attrs({ cellSpacing: 0 })`
  width: 100%;
  border-collapse: collapse;
  border-spacing: 0;
`

export const Header = styled.thead`
  th:first-child {
    border-radius: ${({ theme }) => theme.border.radius.default} ${({ theme }) => theme.border.radius.none}
      ${({ theme }) => theme.border.radius.none} ${({ theme }) => theme.border.radius.default};
  }

  th:last-child {
    border-radius: ${({ theme }) => theme.border.radius.none} ${({ theme }) => theme.border.radius.default}
      ${({ theme }) => theme.border.radius.default} ${({ theme }) => theme.border.radius.none};
  }
`

export const Column = styled.th<ColumnProps>`
  min-width: ${({ $width }) => ($width ? `${$width}px` : 'inherit')};
  color: ${({ theme }) => theme.color.text.neutral.default};
  letter-spacing: ${({ theme }) => theme.font.spacing.spatious};
  font-size: ${({ theme }) => theme.font.size.m2};
  padding: ${({ theme }) => theme.spacing.km4} ${({ theme }) => theme.spacing.km10};
  background: ${({ theme }) => theme.color.background.neutral.weak};
  text-align: left;
  text-transform: capitalize;
`

export const Body = styled.tbody`
  width: 100%;
`

export const Row = styled.tr<RowsProps>`
  width: 100%;
  height: 90px;
  border-bottom: ${({ single, theme }) =>
    single
      ? 'unset'
      : `${theme.border.width.thinner} ${theme.border.style.solid} ${theme.color.border.neutral.default}`};
`

export const Cell = styled.td<CellProps>`
  min-width: ${({ $width }) => ($width ? `${$width}px` : 'inherit')};
  color: ${({ theme }) => theme.color.text.neutral.strong};
  font-size: ${({ theme }) => theme.font.size.m3};
  font-weight: ${({ theme, $fontWeight }) => $fontWeight || theme.font.weight.medium};
  line-height: ${({ theme }) => theme.font.lineHeight.none};
  padding: ${({ theme }) => theme.spacing.km4} ${({ theme }) => theme.spacing.km10};
  text-align: ${({ $textAlign }) => $textAlign || 'unset'};
`
export const MobileWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing.km8};
  width: 100%;
`

export const MobileRowContent = styled.div`
  display: flex;
  width: 100%;
  align-items: center;
  gap: ${({ theme }) => theme.spacing.km2};
  padding-bottom: ${({ theme }) => theme.spacing.km4};

  &:not(:last-child) {
    border-bottom: ${({ theme }) => theme.border.width.thinner} solid
      ${({ theme }) => theme.color.border.neutral.default};
  }
`

export const MobileRowData = styled.div`
  display: flex;
  flex-direction: column;
  width: 90%;
  gap: ${({ theme }) => theme.spacing.km4};
`

export const MobileAction = styled.div``

export const Label = styled(FuelTypography)<LabelProps>`
  ${({ $addElipsis }) =>
    $addElipsis &&
    `
p {
  overflow: hidden;
  text-overflow: ellipsis;
  -webkit-line-clamp: 1; /* number of lines to show */
  line-clamp: 1;
  width: 90%;
  flex-wrap: nowrap;
  white-space: nowrap;
}
`};
`

export const LoaderWrapper = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
  flex-direction: column;
`

export const LoaderRowWrapper = styled.div`
  display: flex;
  align-items: center;
  width: 100%;

  &:not(:last-child) {
    margin-bottom: ${({ theme }) => theme.spacing.km6};
  }
`

export const LoaderHeaderWrapper = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
  gap: ${({ theme }) => theme.spacing.km10};

  &:not(:last-child) {
    margin-bottom: ${({ theme }) => theme.spacing.km10};
  }
`

export const NoDataWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  margin: ${({ theme }) => theme.spacing.km10} ${({ theme }) => theme.spacing.km0};
`
